let didWarnDotValue = false;
function logDotValueWarning() {
  if (didWarnDotValue)
    return;
  didWarnDotValue = true;
  console.warn(
    "Using Signal.value is deprecated and will be removed in the near future. Please use Signal.get() instead."
  );
}
let didWarnComputedGetter = false;
function logComputedGetterWarning() {
  if (didWarnComputedGetter)
    return;
  didWarnComputedGetter = true;
  console.warn(
    `Using \`@computed\` as a decorator for getters is deprecated and will be removed in the near future. Please refactor to use \`@computed\` as a decorator for methods.

// Before
@computed
get foo() {
	return 'foo'
}

// After
@computed
getFoo() {
	return 'foo'
}
`
  );
}
export {
  logComputedGetterWarning,
  logDotValueWarning
};
//# sourceMappingURL=warnings.mjs.map
